import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {
  faEnvelopeCircleCheck,
  faMobile
} from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">

            {/* Company Info */}
            <div className="footer-col">
              <h4 className="footer-title">KP Bakers</h4>
              <p className="footer-text">
                Delight in every bite. We bake fresh, high-quality goodies that taste like home.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                <li><a href="/about">About Us</a></li>
                <li><a href="/contact">Contact Us</a></li>
              </ul>
            </div>

            {/* Contact & Socials */}
            <div className="footer-col">
              <h4 className="footer-title">Contact</h4>
              <div className="footer-contact">
                <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
                <a href="mailto:karanksxxx@gmail.com">karanksxxx@gmail.com</a>
              </div>
              <div className="footer-contact">
                <FontAwesomeIcon icon={faMobile} />
                <span>+91 90414-29065</span>
              </div>
              <div className="social-icons">
                <a href="https://facebook.com/profile.php?id=100070773074829" target="_blank" rel="noreferrer" title="Facebook">
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a href="https://wa.me/9041429065" target="_blank" rel="noreferrer" title="WhatsApp">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
                <a href="https://www.instagram.com/kp.bakers" target="_blank" rel="noreferrer" title="Instagram">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Text */}
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} KP Bakers. All rights reserved.</p>
          </div>
        </div>

        {/* Scoped Styles */}
        <style jsx>{`
          .footer {
            background: #111;
            color: #ccc;
            padding: 40px 0 20px;
            font-family: 'Poppins', sans-serif;
            border-top: 2px solid #00c6ff44;
            box-shadow: 0 -6px 30px rgba(0,198,255,0.07);
          }

          .container {
            max-width: 1140px;
            margin: 0 auto;
            padding: 0 20px;
          }

          .footer-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 40px;
          }

          .footer-col {
            display: flex;
            flex-direction: column;
          }

          .footer-title {
            font-size: 1.1rem;
            color: #00c6ff;
            margin-bottom: 1rem;
            font-weight: 600;
            text-transform: uppercase;
          }

          .footer-text {
            font-size: 0.9rem;
            line-height: 1.6;
            color: #bbb;
          }

          .footer-links {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .footer-links li {
            margin-bottom: 8px;
          }

          .footer-links a {
            color: #eee;
            text-decoration: none;
            transition: color 0.3s;
          }

          .footer-links a:hover {
            color: #00c6ff;
            text-decoration: underline;
          }

          .footer-contact {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            font-size: 0.9rem;
            color: #ccc;
          }

          .footer-contact svg {
            margin-right: 10px;
            color: #00c6ff;
            font-size: 1rem;
          }

          .footer-contact a {
            color: #ccc;
            text-decoration: none;
          }

          .footer-contact a:hover {
            color: #00c6ff;
          }

          .social-icons {
            margin-top: 12px;
          }

          .social-icons a {
            color: #ccc;
            margin-right: 12px;
            font-size: 1.2rem;
            transition: transform 0.3s, color 0.3s;
          }

          .social-icons a:hover {
            transform: scale(1.2);
          }

          .social-icons a[title="Facebook"]:hover {
            color: #3b5998;
          }

          .social-icons a[title="WhatsApp"]:hover {
            color: #25d366;
          }

          .social-icons a[title="Instagram"]:hover {
            color: #e1306c;
          }

          .footer-bottom {
            text-align: center;
            margin-top: 30px;
            font-size: 0.8rem;
            color: #888;
          }

          @media (max-width: 576px) {
            .footer-grid {
              gap: 20px;
            }

            .footer-contact {
              font-size: 0.85rem;
            }

            .social-icons {
              justify-content: center;
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              margin-top: 16px;
            }
          }
        `}</style>
      </footer>
    </>
  );
}
